/**
 * ****************************************************************************
 * @description     :   Route for app module
 * @created at      :   2025/05/25
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
// const Login = () => import('@/views/auth/login');
const AppLogin = () => import('@/views/mobile/app_auth/App_Login');
import APP_WorkReport001 from '@/views/mobile/app_work_report/APP_WorkReport001';
import APP_WorkReport002 from '@/views/mobile/app_work_report/APP_WorkReport002';
import APP_SalesReport001 from '@/views/mobile/app_sales_report/APP_SalesReport001';
import APP_SalesReport002 from '@/views/mobile/app_sales_report/APP_SalesReport002';
/**
 * Defined Router
 */
export default [
    {
        path: '/APP_System/login',
        name: 'APP_System',
        component: AppLogin,
        meta: {
            title: 'ログイン',
            layout: 'MobileEmptyLayout'
        }
    },
    {
        path: '/APP_WorkReport001',
        name: 'APP_WorkReport001',
        component: APP_WorkReport001,
        meta: {
            title: '業務日報一覧',
            layout: 'MobileLayout'
        }
    },
    {
        path: '/APP_WorkReport002',
        name: 'APP_WorkReport002',
        component: APP_WorkReport002,
        meta: {
            title: 'お客様ログイン',
            layout: 'MobileLayout'
        }
    },
    {
        path: '/APP_SalesReport001',
        name: 'APP_SalesReport001',
        component: APP_SalesReport001,
        meta: {
            title: '営業報告登録',
            layout: 'MobileLayout'
        }
    },
    {
        path: '/APP_SalesReport002',
        name: 'APP_SalesReport002',
        component: APP_SalesReport002,
        meta: {
            title: '営業報告登録',
            layout: 'MobileLayout'
        }
    }
];
